import request from '@/api/request'
// 获取公司下拉列表数据
export const getProductLists = (data) => {
  return request({
    url: '/v1/manager/user/product/list',
    method: 'post',
    data: data
  })
}
// 新增产品
export const addProductList = (data) => {
  return request({
    url: '/v1/manager/user/product/add',
    method: 'post',
    data: data
  })
}
// 删除产品
export const deleteProductList = (data) => {
  return request({
    url: '/v1/manager/user/product/delete',
    method: 'post',
    data: data
  })
}
// 更新产品
export const editProductList = (data) => {
  return request({
    url: '/v1/manager/user/product/update',
    method: 'post',
    data: data
  })
}

// 获取公司下拉列表
export const getCompanyList = (data) => {
  return request({
    url: '/v1/manager/user/device/company/list',
    method: 'post',
    data: data
  })
}

//获取产品固件类型列表
export const getProductOtaType = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/GetProductOtaType',
    method: 'post',
    data: data
  })
}
// 添加产品固件类型
export const addProductOtaType = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/AddProductOtaType',
    method: 'post',
    data: data
  })
}
//更新产品固件类型
export const updateProductOtaType = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/UpdateProductOtaType',
    method: 'post',
    data: data
  })
}
//删除产品固件类型
export const deleteProductOtaType = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/DeleteProductOtaType',
    method: 'post',
    data: data
  })
}


